export { useHotkeys as default } from 'react-hotkeys-hook';
